// src/components/auth/AdminGuard.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';

function AdminGuard({ children }) {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (user) {
        // Admin e-posta kontrolü
        if (user.email === 'zaferkeklik@gmail.com') {
          setIsAdmin(true);
          setChecking(false);
          return;
        }

        // Token claims kontrolü
        const token = await user.getIdTokenResult();
        setIsAdmin(token.claims.isAdmin === true);
      }
      setChecking(false);
    };
    checkAdmin();
  }, [user]);

  if (loading || checking) {
    return (
      <div className="min-h-screen bg-[#0A0E23] flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500" />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/membership" replace />;
  }

  return children;
}

export default AdminGuard;